import { Injectable } from '@angular/core';
import { IDependency, IEventSettings, IField, IObjectWithId } from './interfaces';

@Injectable({
    providedIn: 'root'
})
export class EventDataService {
    eventDependencies: IDependency[];
    eventParticipantFields: IField[];
    eventFields: IField[];
    eventParticipant: IObjectWithId;
    eventSettings: IEventSettings;
}
